import { create } from 'zustand';

import { QrCodeFrameItem } from '~/types/qrCode';

type DesignQrSectionState = {
  selectedFrame: QrCodeFrameItem | null;
  setSelectedFrame: (frame: QrCodeFrameItem) => void;
};

const useDesignQRSectionSectionStore = create<DesignQrSectionState>((set) => ({
  selectedFrame: null,
  setSelectedFrame: (frame) => set({ selectedFrame: frame }),
}));

export default useDesignQRSectionSectionStore;
